"use client"

import IframeResizer from "@iframe-resizer/react"
import React, { useEffect, useState } from "react"

interface PardotFormProps {
  src: string
  [key: string]: any
}

const PardotForm: React.FC<PardotFormProps> = (props) => {
  const [search, setSearch] = useState("")
  const { src } = props

  useEffect(() => {
    setSearch(window.location.search)
  }, [])

  return <IframeResizer {...props} license="GPLv3" src={`${src}${search}`} />
}

export default PardotForm
